import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { _className, openContent } from '@nu-art/thunderstorm-frontend/index';
import { ColumnKey_LeftColumn, PanelKey_SmartDocs } from '../../../_shared.js';
import { ICONS } from '@app/styles';
import './AdvisorPanel_SmartDocs.scss';
import { Board_SmartDocs } from '../../../_enum/advisor-board/index.js';
import { Component_SmartDocs_Tabs } from '../../components/smart-docs/Component_SmartDocs_Tabs/Component_SmartDocs_Tabs.js';
import { AdvisorConfigKeyFE_SmartDocs_NoteIds, ModuleFE_EMInterface, ModuleFE_RuntimeSmartNote } from '@app/advisor-frontend';
import { iconTooltipId } from '../../_style/icon-tooltip/index.js';
import { advisorConfig_DevMode, ModuleFE_AdvisorSettings } from '../../../modules/ModuleFE_AdvisorSettings/index.js';
import { Component_SmartDocs } from '../../components/smart-docs/Component_SmartDocs/Component_SmartDocs.js';
import { Debounce } from '@nu-art/ts-common';
import { ToastFilter_LiveMDM } from '../../components/smart-docs/toast.js';
import { ToasterPortal_BottomUp } from '@nu-art/toasting';
export class AdvisorPanel_SmartDocs extends AdvisorPanel {
    static defaultProps = {
        panelKey: PanelKey_SmartDocs,
    };
    updateMDMDebouncer = new Debounce(() => this.updateMDM(), 300);
    //######################### Life Cycle #########################
    __onRuntimeSmartNotesUpdated = (...params) => this.updateMDMDebouncer.trigger();
    __onReadOnlyChanged = () => this.forceUpdate();
    __onAdvisorBoardUpdated = (updatedColumns) => {
        if (updatedColumns.includes(ColumnKey_LeftColumn))
            this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state); // call super derive to resolve readonly mode into the state
        state.quickNoteMode ??= false;
        state.newMDMToView ??= false;
        if (!state.latestMDMTimestamp) {
            const latestMDM = ModuleFE_RuntimeSmartNote.getLatestNote(AdvisorConfigKeyFE_SmartDocs_NoteIds.get()?.mdm);
            state.latestMDMTimestamp = latestMDM?.__updated;
        }
        return state;
    }
    componentDidUpdate() {
        if (!Board_SmartDocs.isOpen()) // @ts-ignore
            this.state.quickNoteMode = false;
        else if (this.state.newMDMToView) {
            // @ts-ignore
            this.state.newMDMToView = false;
            this.forceUpdate();
        }
    }
    //######################### Logic #########################
    getPanelClass() {
        return _className(super.getPanelClass(), 'panel__smart-docs', Board_SmartDocs.isOpen() && 'open', this.state.newMDMToView && 'mdm-to-view');
    }
    onPanelClick = (e) => {
        Board_SmartDocs.open();
    };
    updateMDM = async () => {
        const latestMDM = ModuleFE_RuntimeSmartNote.getLatestNote(AdvisorConfigKeyFE_SmartDocs_NoteIds.get()?.mdm);
        if (!latestMDM)
            return;
        if (!this.state.latestMDMTimestamp) //@ts-ignore
            return this.state.latestMDMTimestamp = latestMDM.__updated;
        if (latestMDM.__updated <= this.state.latestMDMTimestamp)
            return;
        //Disable mdm toast for now
        // Toast_LiveMDM.toast('live-mdm', {
        // 	body: 'MDM has been updated',
        // });
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                this.setState({
                    latestMDMTimestamp: latestMDM.__updated,
                    newMDMToView: !Board_SmartDocs.isOpen(),
                }, () => resolve());
            }, 1800);
        });
    };
    //######################### Render - Header #########################
    renderHeader_Title = () => {
        return 'Notes';
    };
    renderHeader_Tail = () => {
        const isOpen = Board_SmartDocs.isOpen();
        const postDispo = ModuleFE_EMInterface.isPostDisposition();
        return _jsxs(_Fragment, { children: [!postDispo && _jsx(_Fragment, { children: _jsx(ICONS.advisor_avn_addNote.component, { ...openContent.tooltip.top(iconTooltipId, 'Add note to MDM summary', { offset: 8 }), onClick: e => {
                            this.onPanelClick(e);
                            setTimeout(() => this.setState({ quickNoteMode: true }));
                        } }) }), isOpen && _jsx(ICONS.advisor_avn_close.component, { onClick: () => {
                        Board_SmartDocs.close();
                    } })] });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = undefined;
    //######################### Render - Content #########################
    _renderContent = (scrollRef) => {
        const devMode = ModuleFE_AdvisorSettings.getAdvisorConfig(advisorConfig_DevMode);
        if (devMode)
            return _jsx(Component_SmartDocs_Tabs, { scrollRef: scrollRef });
        return _jsx(Component_SmartDocs, { quickNoteMode: this.state.quickNoteMode, onCloseQuickNote: () => this.setState({ quickNoteMode: false }) });
    };
    renderContent = () => _jsx(_Fragment, {});
    //######################### Render - Footer #########################
    renderFooter = undefined;
    //######################### Render - Extra Content #########################
    render_extraPanelContent = () => _jsx(ToasterPortal_BottomUp, { height: 200, bottomOffset: 8, modelFilter: ToastFilter_LiveMDM });
}
//# sourceMappingURL=AdvisorPanel_SmartDocs.js.map